import type { ReactNode } from "react";

type ModalOverlayProps = {
  children: ReactNode;
  onClose?: () => void;
};

export const ModalOverlay = ({ children, onClose }: ModalOverlayProps) => {
  return (
    <div
      className="fixed inset-0 bg-black/50 z-overlay flex items-center justify-center text-white"
      onClick={
        onClose
          ? (e) => {
              // モーダル内のクリックが親に伝播しないようにする
              if (e.target === e.currentTarget) {
                onClose();
              }
            }
          : undefined
      }
    >
      {children}
    </div>
  );
};
